import { useLayoutEffect, useRef } from "react";

/**
 * WebKit (esp. iOS) can synthesize a delayed `click` after `touchend` when the DOM
 * updates before that click fires — the click lands on whatever replaced the control
 * at the same screen position (e.g. wizard Continue → password Submit).
 *
 * useLayoutEffect runs before paint so the guard is in place before a same-frame click.
 */
export function useAccidentalSubmitGuard(active: boolean, ms = 500) {
  const guardUntilRef = useRef(0);

  useLayoutEffect(() => {
    if (active) {
      guardUntilRef.current = Date.now() + ms;
    }
  }, [active, ms]);

  const armGuard = () => {
    guardUntilRef.current = Date.now() + ms;
  };

  return {
    shouldSuppressSubmit: () => Date.now() < guardUntilRef.current,
    armGuard,
  };
}
